import { ConfirmModalParams, ModalParams } from 'core/models';
import { action, observable, makeObservable } from 'mobx';

class BaseViewStore {
	@observable loading = false;
	@observable pendingLoading = false;
	timeoutDuration = 2000;

	@action
	suspend = () => {
		this.loading = true;
		clearTimeout(this.pendingLoading);
		this.pendingLoading = null;
	};

	@action
	resume = () => {
		this.loading = false;
		clearTimeout(this.pendingLoading);
		this.pendingLoading = null;
	};

	@action
	pendingLoadingSuspend = () => {
		if (this.pendingLoading) {
			return;
		}
		this.pendingLoading = setTimeout(this.suspend, this.timeoutDuration);
	};

	@action
	openConfirmationModal = ({ message, data, ...props }) => {
		this.rootStore.viewStore.selectedConfirmModal = new ConfirmModalParams({ ...props });
		this.rootStore.viewStore.selectedConfirmModal.open({ message: message }, data);
	};

	@action
	openModal = ({ data, ...props }) => {
		this.rootStore.viewStore.selectedModal = new ModalParams({ ...props });
		this.rootStore.viewStore.selectedModal.open(data);
	};

	@action
	openNestedModal = ({ data, ...props }) => {
		if (!this.rootStore.viewStore.nestedModal) {
			this.rootStore.viewStore.nestedModal = { [props.name]: new ModalParams({ ...props }) };
		} else {
			this.rootStore.viewStore.nestedModal[props.name] = new ModalParams({ ...props });
		}

		this.rootStore.viewStore.nestedModal[props.name].open(data);
	};

	constructor(rootStore) {
		makeObservable(this);
		this.rootStore = rootStore;
	}
}

export default BaseViewStore;



// WEBPACK FOOTER //
// ./src/core/stores/BaseViewStore.js